import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../service/axios/axios'
import './Message.css'
import {format} from 'timeago.js'
function Message({mesgs,own, auth}) {
    const [otherUser, setOtherUser] = useState(null)
    console.log('mesgs', mesgs)
    useEffect(() => {
       
        const getUser = async () => {
            try {
              const res =  await axiosInstance.get(`/users/user?user_id=${mesgs?.sender_id}`)
              setOtherUser(res.data)
            } catch (error) {
                console.log('error', error)
            }
        }
        getUser()

    },[mesgs])
    console.log('mesgs', mesgs)
  return (
    <div className={`message ${own ? 'own' : ''}`}>
        <div className='messageTop'>
            {own ? (
                <img className='messageImage' src={auth?.user?.profile_image ? auth?.user?.profile_image: '/images/dev/user.png'} alt="officer" />
                ): (
                <img className='messageImage' src={otherUser?.profile_image ? otherUser?.profile_image : '/images/dev/user.png'} alt="officer" />

            )}
            <div className='messageText'>{mesgs?.message}</div>
            
        </div>
        <div className='messageBottom'>{format(mesgs?.data)} </div>
    </div>
  )
}

export default Message